import { action } from 'typesafe-actions';

const entity = 'news';

const GET_NEWS = `${entity}/GET_NEWS`;
const SET_NEWS = `${entity}/SET_NEWS`;

const actionGetNews = () => action(GET_NEWS);
const actionSetNews = (news: any) => action(SET_NEWS, news);

export { GET_NEWS, SET_NEWS, actionGetNews, actionSetNews };
